<div class="scrollable">
    <panel [noButton]="true">
        <h5>Editar o Crear Grupo</h5>
        <div class="row" [formGroup]="groupForm">
            <div class="col-md-6  my-2">
                Nombre:
                <input type="text" class="form-control" formControlName="name">
            </div>
            <div class="col-md-6 col-xl-4 my-2">
                Sigla:
                <input type="text" class="form-control" formControlName="acronym">
            </div>
        </div>
        <div class="modal-footer mt-5">
            <button class="btn btn-danger btn-xs mx-1" (click)="cancel()">Cancelar</button>
            <button class="btn btn-primary btn-xs mx-1" (click)="save()">Guardar</button>
        </div>


    </panel>
</div>